import { Box, Typography } from '@mui/material'
import { PageHeader } from 'components/Shared/PageHeader'
import { LEConnectUserDetailPageTabs } from './LEConnectUserDetailPageTabs'
import { type useUserData } from 'hooks/api/useUserData'
import { isNil } from 'lodash'
import { useLayout } from 'hooks/useLayout'

export const LeConnectUserDetailsHeader = ({
  user,
  formattedUpdatedAt,
  formattedLastAccessed,
  userName,
  currentTab,
}: {
  user: ReturnType<typeof useUserData>['user']
  formattedUpdatedAt: string | null
  formattedLastAccessed: string | null
  userName: string | null
  currentTab: 'Overview'
}) => {
  if (isNil(user) || isNil(userName)) {
    return null
  }
  const { isMobile } = useLayout()

  return (
    <PageHeader
      title={userName}
      isSecondary={true}
      backPath="/LicensedEstablishmentUsers"
      backText="J&J Connect Users"
      customSubTitle={
        <Box
          className={
            isMobile ? '' : 'flex flex-row items-center self-stretch gap-4 mb-4'
          }
        >
          {formattedUpdatedAt && (
            <Typography variant="body-1" color={'text.secondary'}>
              {formattedUpdatedAt}
            </Typography>
          )}

          {formattedLastAccessed && (
            <>
              {!isMobile && <Typography color={'text.secondary'}>|</Typography>}
              <Typography variant="body-1" color={'text.secondary'}>
                {formattedLastAccessed}
              </Typography>
            </>
          )}
        </Box>
      }
      tabs={
        <LEConnectUserDetailPageTabs
          currentTab={currentTab}
          leuserId={user.id}
        />
      }
    />
  )
}
